import React from "react";
import { Card } from "react-bootstrap";
import { css } from "@emotion/css"

const ChoiceCard = ({ body, header, onClick = () => { }, className }) => {
    return (
        <>
            <Card
                className={"h-100 " + css`
                &:hover {
                    cursor: pointer;
                }
            ` + ` ${className}`}
                onClick={() => onClick()}>
                {
                    header &&
                    <Card.Header className={"d-flex justify-content-center "
                        + css`font-size: 22px`
                    }>
                        {header}
                    </Card.Header>
                }

                <Card.Body className={"d-flex justify-content-center align-items-center "
                    + css`font-size: 20px`
                }>
                    {body}
                </Card.Body>
            </Card>
        </>
    );
};

export default ChoiceCard;